module.exports = __webpack_public_path__ + "img/wood.20849c0e.png";